<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="gotochangebankdetails()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                {{ addBankingDetails ? 'Add Banking Details' : 'Amend Banking Details' }} </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">

            <!-- 🔍 Search Section (only show if NOT addBankingDetails) -->
            <div class="row mt-3" *ngIf="!addBankingDetails">
                <div class="col-xl-3 d-none d-md-block">
                </div>
                <div class="col-xl-5 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                        style="margin-bottom: 1rem !important;">
                        <mat-label>Search</mat-label>
                        <div class="search-input-container">
                            <input formControlName="searchQuery" placeholder="Enter Email / Refernce Number" id="search"
                                matInput type="text" #searchInput>
                        </div>
                    </mat-form-field>
                    <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                        (click)="search()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>
                </div>
                <button type="button" class="btn reset_btn" (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> reset
                </button>
            </div>


            <!-- 🏦 Banking Information Card (always show if addBankingDetails OR showdata) -->
            <div *ngIf="addBankingDetails || showdata">

                <!-- Banking Information -->

                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Banking Information</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="row mx-4">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Bank</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="bank"
                                        (selectionChange)="getbranchcode()" placeholder="Select Bank ">
                                        <mat-select-filter [displayMember]="'value'" [array]="bankList"
                                            (filteredReturn)="filteredList = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList" [value]="item.name"
                                            style="overflow-y: scroll !important;">
                                            {{item.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Branch Code</mat-label>
                                    <input matInput maxlength="25" formControlName="code" placeholder="Enter  Bank code"
                                        class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-4">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Account NO</mat-label>
                                    <input matInput (keypress)="restrictSpace($event)" maxlength="25"
                                        (keypress)="allowOnlyNumbers($event)" formControlName="accountNumber"
                                        placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Type Of Account</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="accountType"
                                        placeholder="Select Type Of Account">
                                        <mat-select-filter [displayMember]="'value'" [array]="typeofaccount"
                                            (filteredReturn)="typeofaccount = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of typeofaccount" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-4">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Date Of Debit Order Run</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="dateOfDebitOrderRun"
                                        placeholder="Select Date of debit order run">
                                        <mat-select-filter [displayMember]="'value'" [array]="debitorder"
                                            (filteredReturn)="debitorder = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of debitorder" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-8 col-xl-6 mt-5">
                                <div class="col-sm-12 col-md-6" style="display: flex; align-items: center;">
                                    <label style="margin-right: 50px; font-size: large; white-space: nowrap;">Is
                                        EFT</label>
                                    <mat-checkbox formControlName="isEFT" style="transform: scale(1.3);"
                                        color="primary"></mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- 📂 Document Details (only show if NOT addBankingDetails) -->
                <div class="container mt-3" *ngIf="!addBankingDetails && showdata">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Document Details</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="table-responsive mt-2 ">
                            <mat-table #table [dataSource]="dataSource">

                                <ng-container matColumnDef="DocumentType" class="mat-table">
                                    <mat-header-cell *matHeaderCellDef>Document Type</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.documenttype}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Date" class="mat-table">
                                    <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.date}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="FileName" class="mat-table">
                                    <mat-header-cell *matHeaderCellDef> File Name</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.filename}} </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Action" class="mat-table">
                                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <div class="text-truncate text-center">
                                            <i style="cursor: pointer;font-size: 20px;color: #9B02DB;"
                                                class="fa fa-file-import mr-3" *ngIf="!dataField.action"
                                                (click)="fileupload()"></i>
                                            <i style="cursor: pointer;font-size: 20px;color: red;"
                                                class="fa fa-close mr-3" *ngIf="dataField.action"
                                                (click)="fileupload()"></i>
                                        </div>
                                    </mat-cell>
                                </ng-container>


                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                                </mat-row>
                            </mat-table>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end button-style mt-5">
                    <button class="btn btn-secondary mb-2" type="submit" (click)="save()" matButton>Submit</button>
                </div>
            </div>

        </form>


    </div>
</div>